const EventsDetail = [
  {
    name: "Gen AI Galaxy",
    description:
      "Google Developer Student Club (GDSC) and Each One Save One (EOSO) visit a deaf and mute school. Eager to connect with the students, we prepare with visual aids and activities to overcome communication barriers. We aim to leave a lasting impression, highlighting the power of genuine connections and the importance of embracing diversity with empathy.",
    img: "/images/Events/GenAi.png",
    Date: "20th January, 2024",
    Time: "11:30 AM",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-gen-ai-galaxy/",
    bkgclr: "",
    isLeft: "",
    bufferBtnName: "",
    bufferBtnLink: "",
    location: "RC Patel School - Savalde, Shirpur, 425405",
  },
  {
    name: "SilentJoy Carnival",
    description:
      "An enchancing event dedicated to spreading smiles and creating lasting memories at the Deaf and Mute School. In this unique celebration, the focus is on fostering joy, connection, and inclusivity. While the carnival may not include traditional technology lessons, its essence lies in the simple yet profound joy of human connection.",
    img: "/images/Events/SilentJoy.png",
    Date: "14th January, 2024",
    Time: "02:00 PM",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-silentjoy-carnival/",
    bkgclr: "",
    isLeft: "true",
    bufferBtnName: "",
    bufferBtnLink: "",
    location: "Deaf and Mute School, Shirpur, 425405",
  },
  {
    name: "MLMarvel - Kids' Workshop",
    description:
      "An exciting and interactive learning experience designed for young minds eager to explore the wonders of Machine Learning! Through hands-on exploration of 'Teachable Machines,' we aspire to spark their interest, paving the way for a journey of discovery and curiosity in the realm of technology for Anand Sadan School Children.",
    img: "/images/Events/MLMarvel.png",
    Date: "14th January, 2024",
    Time: "02:00 PM",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-mlmarvel-kids-workshop/",
    bkgclr: "",
    isLeft: "",
    bufferBtnName: "",
    bufferBtnLink: "",
    location: "Anand Sadan School, Shirpur, 425405",
  },
  {
    name: "InfoInsight - Google Solution Challenge",
    description:
      "This is an info session as a part of Solution Challenge. The Solution Challenge is a global annual content hosted by Google. Whether you're a student, developer, or technology enthusiast, this interactive info session is your gateway to understanding the challenge, its goals, and how you can participate.",
    img: "/images/Events/solutionchallenge.jpeg",
    Date: "15th December, 2023",
    Time: "05:00 PM",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-developer-dsa-series-session-2/",
    bkgclr: "",
    isLeft: "true",
    bufferBtnName: "",
    bufferBtnLink: "",
    location:
      "Seminar Hall-1, C - Wing 2nd Floor - MPSTME Shirpur Shirpur, 425405",
  },
  {
    name: "Google Cloud Study Jam",
    description:
      "From containerizing applications to creating virtual machines, Study Jams can be tailored to specific Cloud topics and skill levels. Whether you’re a beginner developer or interested in diving into Machine Learning, BigQuery, Certification, or Kubernetes - there's a track for you. You'll learn the fundamental tools and capabilities of Google Cloud with free access to hands-on labs. ",
    img: "/images/Events/GCP2024.jpeg",
    Date: "17th October, 2023",
    Time: "05:00 PM",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-google-cloud-study-jam-1/",
    bkgclr: "",
    isLeft: "",
    bufferBtnName: "",
    bufferBtnLink: "",
    location:
      "Seminar Hall-1, C - Wing 2nd Floor - MPSTME Shirpur Shirpur, 425405",
  },
  {
    name: "CodeKraken x NMIMS",
    description:
      "The CodeKraken Hackathon is  an event dedicated to innovation and open-source projects. Whether you're passionate about AI, web development, or any other tech domain, this is your chance to showcase your skills and creativity. This is the opportunity to collaborate with fellow students, apply knowledge, and win from exciting cash prize pool INR 50,000. ",
    img: "/images/Events/codekraken.jpeg",
    Date: "10th September, 2023",
    Time: "09:30 AM",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-developer-dsa-series-session-2/",
    bkgclr: "",
    isLeft: "true",
    bufferBtnName: "",
    bufferBtnLink: "",
    location:
      "Seminar Hall-1, C - Wing 2nd Floor - MPSTME Shirpur Shirpur, 425405",
  },
  {
    name: "Three C's of Success",
    description:
      " The session commenced with an introduction to the three C's: Coding, Cloud/Computing, College/Corporate, and explained the importance of Git-Hub. The speakers provide key insights on how Coding/Competitve coding can help students to crack placements.",
    img: "/images/Events/3csuccess.jpeg",
    Date: "9th September, 2023",
    Time: "10:00 AM",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-three-cs-of-success/",
    bkgclr: "",
    isLeft: "",
    bufferBtnName: "",
    bufferBtnLink: "",
    location:
      "Seminar Hall-1, C - Wing 2nd Floor - MPSTME Shirpur Shirpur, 425405",
  },
  {
    name: "DSA Series Session 2",
    description:
      "The Standard Template Library (STL) is a collection of powerful generic algorithms, containers, and iterators that are part of the C++ standard library. It provides a set of ready-to-use tools for solving common programming problems, such as sorting, searching, and manipulating data structures.",
    img: "/images/Events/DSASDay2.jpg",
    Date: "19th February, 2022",
    Time: "11:00 AM",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-developer-dsa-series-session-2/",
    bkgclr: "",
    isLeft: "true",
    bufferBtnName: "",
    bufferBtnLink: "",
    location:
      "Seminar Hall-1, C - Wing 2nd Floor - MPSTME Shirpur Shirpur, 425405",
  },
  {
    name: "DSA Series Session 1",
    description:
      "DSA (Data Structures and Algorithms) is an important concept in computer science and programming because it provides a way to efficiently solve complex problems.  DSA is used to organize and manipulate data efficiently, and to develop algorithms that can process that data in the most effective way possible.",
    img: "/images/Events/DSASDay1.jpg",
    Date: "18th February, 2022",
    Time: "11:00 AM",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-developer-dsa-series-session-1/",
    bkgclr: "",
    isLeft: "",
    bufferBtnName: "",
    bufferBtnLink: "",
    location:
      "Seminar Hall-1, C - Wing 2nd Floor - MPSTME Shirpur Shirpur, 425405",
  },
  {
    name: "Web Campaign Day 3",
    description:
      "JavaScript is a crucial tool for creating dynamic and interactive web pages, and its importance in web development continues to grow. Firebase website deployment provides a reliable and easy-to-use platform for hosting your website and ensuring that it is fast, secure, and scalable. ",
    img: "/images/Events/WebDay3.jpg",
    Date: "17th February, 2022",
    Time: "9:30 PM",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-web-campaign-day-3-javascript/",
    bkgclr: "",
    isLeft: "true",
    bufferBtnName: "",
    bufferBtnLink: "",
  },
  {
    name: "Web Campaign Day 2",
    description:
      "JavaScript is a popular programming language used to create dynamic and interactive web pages. It is an essential tool for front-end web developers as it enables them to build and implement features that enhance the user experience of a website.",
    img: "/images/Events/WebDay2.jpg",
    Date: "15th February, 2022",
    Time: "9:30 PM",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-web-campaign-day-2-introduction-to-javascript/",
    bkgclr: "",
    isLeft: "",
    bufferBtnName: "",
    bufferBtnLink: "",
  },
  {
    name: "Web Campaign Day 1",
    description:
      "HTML and CSS are two fundamental technologies used for creating web pages and web applications. While HTML provides the structure and content of a web page, CSS is responsible for its appearance and styling.",
    img: "/images/Events/WebDay1.jpg",
    Date: "13th February, 2022",
    Time: "9:30 PM",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-web-campaign-day-1-html-css/",
    bkgclr: "",
    isLeft: "true",
    bufferBtnName: "",
    bufferBtnLink: "",
  },
  {
    name: "Cloud Campaign Study Jam",
    description:
      "Google Cloud Platform (GCP) is a suite of cloud computing services provided by Google. This study jam is going to be an open panel discussion for the Cloud campaign participant to ask their doubts and difficulties that they are facing in the campaign directly to the facilitator.",
    img: "/images/Events/Study Jam.jpeg",
    Date: "27th December, 2022",
    Time: "4:45 PM",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-cloud-campaign-study-jam-1/",
    bkgclr: "",
    isLeft: "",
    bufferBtnName: "",
    bufferBtnLink: "",
  },
  {
    name: "Compose Camp Volume 2",
    description:
      "Compose Camp are community-organised events focused around how to build Android apps using Jetpack Compose, where attendees get hands-on coding experience with Compose",
    img: "/images/Events/compose camp vol2.jpg",
    Date: "18th September, 2022",
    Time: "6:00 PM",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-compose-camp-volume-2/",
    bkgclr: "",
    isLeft: "true",
    bufferBtnName: "",
    bufferBtnLink: "",
  },
  {
    name: "Compose Camp Volume 1",
    description:
      "Compose Camp are community-organised events focused around how to build Android apps using Jetpack Compose, where attendees get hands-on coding experience with Compose",
    img: "/images/Events/Compose Camp.png",
    Date: "8th September, 2022",
    Time: "9:00 AM",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-compose-camp-volume-1/",
    bkgclr: "",
    isLeft: "",
    bufferBtnName: "",
    bufferBtnLink: "",
    location:
      "Amrishbhai R Patel School - Karwand Naka, Shahada Rd, opp. H.P. Petrol Pump Shirpur, 425405",
  },
  {
    name: "Developer++ Volume 1",
    description:
      "Developer++ Vol1 is a C++ workshop organized to brush up the basic C++ and problem solving. This will be a multi-volume series for C++, which will cover all the basic concepts, Object Oriented Programming, Data Structures and Algorithms & many more.",
    img: "/images/Events/Developer++.png",
    Date: "28th August, 2022",
    Time: "2:30 PM",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-developer-volume1/",
    bkgclr: "",
    isLeft: "true",
    bufferBtnName: "",
    bufferBtnLink: "",
    location:
      "Conference Hall, C - Wing 2nd Floor - MPSTME Shirpur Shirpur, 425405",
  },
  {
    name: "The Community Sync",
    description:
      "Only 60 seats so register as soon as possible. Engaging Games and activities with community members. Google Solution Challenge. Win exciting goodies from Google DSC! Join us in the Event to know more.",
    img: "/images/Events/2022SolutionChallenge.png",
    Date: "12th March, 2022",
    Time: "4:00 pm",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-the-community-sync/",
    bkgclr: "",
    isLeft: "",
    bufferBtnName: "",
    bufferBtnLink: "",
    location:
      "Seminar Hall, C - Wing 2nd Floor - MPSTME Shirpur Shirpur, 425405",
  },
  {
    name: "Introduction to Python Programming",
    description:
      "Python is a computer programming language often used to build websites and software, automate tasks, and conduct data analysis. This versatility, along with its beginner-friendliness, has made it one of the most-used programming languages today. Join us in the Event to know more.",
    img: "/images/Events/PythonWorkshop.png",
    Date: "6th February, 2022",
    Time: "11:00 am",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-introduction-to-python-programming/",
    bkgclr: "white",
    isLeft: "true",
    bufferBtnName: "",
    bufferBtnLink: "",
  },
  {
    name: "Android Study Jam: Introduction",
    description:
      "Android has dominated the global market share of smartphone operating systems for several years. Android application development is a recognized industry occupation as a full-time career option. Join us in the Event to know more.",
    img: "/images/Events/AJSIntro.jpeg",
    Date: "8th December, 2021",
    Time: "6:00 pm",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-android-study-jam/",
    bkgclr: "",
    isLeft: "",
    bufferBtnName: "",
    bufferBtnLink: "",
  },
  {
    name: "Dive in DC at Five",
    description:
      "We believe that decentralized computing will mark a transition away from cloud computing and is the next major wave of computing. Let’s have a talk about building innovative products using Enterprise Blockchain Architecture. With live demo from Mr. Shankar Ganesh by using Decentralized Social Network, Blockstack and cool new protocols.",
    img: "/images/Events/DecentralizedComputing.png",
    Date: "16th October, 2021",
    Time: "4:45 pm",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-dive-in-dc-at-five/",
    bkgclr: "white",
    isLeft: "true",
    bufferBtnName: "",
    bufferBtnLink: "",
  },
  {
    name: "Info Session: An Evening on Cloud 9",
    description:
      "Community is what makes us who we are. And we as the Google Developer Student Club at MPSTME, Shirpur want to get to know our community better. Keeping the idea in mind, we are formally inviting you to An Evening on Cloud Nine with GDSC MPSTME, Shirpur.",
    img: "/images/Events/InfoSession.png",
    Date: "25th September, 2021",
    Time: "6:00 pm",
    SiteName: "Know More",
    link: "https://gdsc.community.dev/events/details/developer-student-clubs-mukesh-patel-school-of-technology-management-and-engineering-shirpur-presents-an-evening-on-cloud-9-with-gdsc-mpstme-shirpur/",
    bkgclr: "",
    isLeft: "",
    bufferBtnName: "",
    bufferBtnLink: "",
  },
];

export default EventsDetail;
